import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLayoutManagementStore } from "src/hooks/stores";

import getCookie from "@vfuk/core-helpers/dist/getCookie";
import TopNavigation from "@vfuk/core-top-navigation";
import {
  TopNavigationProps,
  UserProps,
} from "@vfuk/core-top-navigation/dist/TopNavigation.types";

import { useProfileModal } from "@ucchub/ui";

const TopNavBar = () => {
  // Get the current navbar data from global store
  const navbarData = useLayoutManagementStore((state) => state.navbar);
  const isLoggedIn = getCookie("Token") || false;
  const navigate = useNavigate();
  const { setNavbarUser } = useProfileModal();

  const { call: getNavbar } = useLayoutManagementStore(
    (state) => state.getNavbar
  );

  const { toggle: toggleUserModal } = useProfileModal();

  // Fetch Navbar links from the API on Load
  useEffect(() => {
    const getNavbarDataAsync = async () => {
      const result = await getNavbar();

      if (!result) {
        setNavbarUser({
          name: "",
          email: "",
          initials: "",
          role: "",
        });
        return;
      }

      const userData = result.secondaryNav?.user?.data
        ? (result.secondaryNav?.user?.data as UserProps & {
            email: string;
            name: string;
            initials: string;
            role: string;
          })
        : undefined;

      setNavbarUser({
        name: userData?.name || "",
        email: userData?.email || "",
        initials: userData?.initials ? userData.initials : "",
        role: userData?.role || "",
      });
    };
    getNavbarDataAsync();
  }, [getNavbar]);

  // Attach a `onClick` to the User profile icon.
  useEffect(() => {
    const userButton = document.getElementById("user");
    if (userButton) {
      userButton.onclick = () => {
        isLoggedIn ? toggleUserModal() : navigate("/login");
        return;
      };
    }
  }, [isLoggedIn, navigate, toggleUserModal]);

  // Temporary workaround for the TopNavigation component
  interface oldLink {
    url?: string;
    links: oldLink[];
  }

  // For all the links with a `url` property, add an onClick property and remove the `url` property
  // This is a temporary fix for the full-reload bug. It's because @vfuk/core-link doesn't support `to` prop.
  const navbarLinks = navbarData.primaryNav.links.map((oldLink) => {
    const link = oldLink as oldLink;

    if (link.url || link.links) {
      return {
        ...link,
        links: link.links?.map((subLink) => {
          return {
            ...subLink,
            links: subLink?.links?.map((subSubLink) => {
              return {
                ...subSubLink,
                url: "",
                onClick: () =>
                  subSubLink.url ? navigate(subSubLink.url) : undefined,
              };
            }),
          };
        }),
        url: "",
        onClick: () => (link.url ? navigate(link.url) : undefined),
      };
    }
    return link;
  });

  // If there is no data, return nothing
  if (!navbarData) return null;

  return (
    <TopNavigation
      zIndex={13}
      primaryNav={
        {
          ...navbarData.primaryNav,
          links: navbarLinks,
        } as unknown as TopNavigationProps["primaryNav"]
      }
      logo={{
        ...navbarData.logo,
        onClick: () => navigate("/"),
      }}
      secondaryNav={{
        user: {
          // If the `data` field is not empty, the user is logged in
          id: "user",
          data:
            navbarData.secondaryNav && navbarData.secondaryNav.user?.data
              ? { initials: navbarData.secondaryNav.user.data.initials }
              : undefined,
          login: {
            id: "",
            text: "",
          },
          logout: {
            id: "",
            text: "",
          },
          srText: "Log in to your Vodafone account",
        },
      }}
      mobileNavTrigger={navbarData.mobileNavTrigger}
      sideNavigationCloseButton={{
        id: "side-navigation-close-button",
        srText: "Close side navigation",
      }}
      skipLink={
        navbarData.skipLink as unknown as TopNavigationProps["skipLink"]
      }
      dataAttributePrefix="top-navigation"
    />
  );
};

export default TopNavBar;
